
angular.module('bmsApp.employeeEmergencyDetail', []);
